import { createStyles } from '@material-ui/styles';

export default (overrideWidth?: boolean) =>
  createStyles({
    root: {
      width: '100%',

      '& .MuiFormControl-root': {
        width: '100%',
      },

      '& .MuiAutocomplete-option': {
        fontSize: 12,
      },

      '& .MuiAutocomplete-inputRoot': {
        width: !overrideWidth ? '95%' : '100%',
      },
    },
    textField: {
      fontSize: 12,
      alignItems: 'center',
      '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
        height: 45,
      },

      '& .PrivateNotchedOutline-root': {
        left: 8,
      },
    },
  });
